const PurchaseMonitoring = () => import(/* webpackChunkName: "purchaseMonitoring" */ './PurchaseMonitoring.vue')

const index = {
  path: 'purchase/monitoring',
  name: 'Purchase Monitoring',
  component: PurchaseMonitoring,
  meta: {
    requiresLogin: true,
    requiresCompany: true,
    permissions: []
  }
}

export default {
  index
}
